import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { VideoComponent } from './video/video.component';
import { VideoYoutubeComponent } from './video-youtube/video-youtube.component';
import { MediaComponent } from './media/media.component';

@NgModule({
  imports: [CommonModule, SkeletonCommonModule],
  exports: [VideoComponent, VideoYoutubeComponent],
  declarations: [VideoComponent, VideoYoutubeComponent, MediaComponent]
})
export class VideoModule {}
